const OfferList = ({ text }: { text: string }) => {
  return (
    <p className={`mb-1 text-base text-body-color dark:text-dark-6`}>{text}</p>
  );
};

export default OfferList;
